// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav_navContainer__aVgoO {
    background-color: #FFF;
}

.nav_navLinks__mbBvr, .nav_navSection__zD7ap {
    justify-content: center;
}

.nav_navSection__zD7ap {
    flex-direction: column;
    gap: clamp(16px, 3vw, 90px);
    position: relative;
}

.nav_navLinks__mbBvr {
    background-color: #F4CE14;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: none;
    flex-direction: column;
    gap: clamp(8px, 2vw, 40px);
    margin-top: 10px;
    position: absolute;
    right: 0;
    top: 100%;
    width: 50%;
    z-index: 999;
}

.nav_navLinksOpen__LzLhN {
    display: flex;
}

.nav_navLinks__mbBvr li {
    width: 100%;
    text-align: center;
}

.nav_navLinks__mbBvr li:hover {
    background-color: #495e57;
}

.nav_navLinks__mbBvr li a {
    display: block;
    font-size: clamp(11pt, 1.5vw, 16pt);
    padding: 12px;
    white-space: nowrap;
}

.nav_navContainer__aVgoO figure {
    width: clamp(120px, 20vw, 200px);
}

.nav_navContainer__aVgoO figure img {
    width: 100%;
    height: auto;
}

.nav_hamburger__yCAAN {
    background: none;
    border: none;
    cursor: pointer;
    height: fit-content;
    padding: 0;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: fit-content;
    z-index: 10;
}

.nav_hamburger__yCAAN:hover {
    background: none;
}

@media (max-width: 1024px) {
    .nav_navLinks__mbBvr li a:visited {
        color: #495e57;
    }

    .nav_navLinks__mbBvr li:hover a:visited {
        color: #FFF;
    }
}

@media (min-width: 1025px) {
    .nav_hamburger__yCAAN {
        display: none;
    }

    .nav_navContainer__aVgoO {
        padding-bottom: 10px;
        padding-top: 10px;
    }

    .nav_navSection__zD7ap {
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }

    .nav_navLinks__mbBvr {
        background-color: transparent;
        box-shadow: none;
        display: flex;
        flex-direction: row;
        position: relative;
        width: auto;
        z-index: 0;
    }

    .nav_navLinks__mbBvr li:hover {
        background-color: transparent;
    }

    .nav_navLinks__mbBvr li a {
        padding: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Nav/nav.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,mCAAmC;IACnC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;QAC9B,WAAW;IACf;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,kBAAkB;QAClB,WAAW;QACX,UAAU;IACd;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".navContainer {\n    background-color: #FFF;\n}\n\n.navLinks, .navSection {\n    justify-content: center;\n}\n\n.navSection {\n    flex-direction: column;\n    gap: clamp(16px, 3vw, 90px);\n    position: relative;\n}\n\n.navLinks {\n    background-color: #F4CE14;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    display: none;\n    flex-direction: column;\n    gap: clamp(8px, 2vw, 40px);\n    margin-top: 10px;\n    position: absolute;\n    right: 0;\n    top: 100%;\n    width: 50%;\n    z-index: 999;\n}\n\n.navLinksOpen {\n    display: flex;\n}\n\n.navLinks li {\n    width: 100%;\n    text-align: center;\n}\n\n.navLinks li:hover {\n    background-color: #495e57;\n}\n\n.navLinks li a {\n    display: block;\n    font-size: clamp(11pt, 1.5vw, 16pt);\n    padding: 12px;\n    white-space: nowrap;\n}\n\n.navContainer figure {\n    width: clamp(120px, 20vw, 200px);\n}\n\n.navContainer figure img {\n    width: 100%;\n    height: auto;\n}\n\n.hamburger {\n    background: none;\n    border: none;\n    cursor: pointer;\n    height: fit-content;\n    padding: 0;\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: fit-content;\n    z-index: 10;\n}\n\n.hamburger:hover {\n    background: none;\n}\n\n@media (max-width: 1024px) {\n    .navLinks li a:visited {\n        color: #495e57;\n    }\n\n    .navLinks li:hover a:visited {\n        color: #FFF;\n    }\n}\n\n@media (min-width: 1025px) {\n    .hamburger {\n        display: none;\n    }\n\n    .navContainer {\n        padding-bottom: 10px;\n        padding-top: 10px;\n    }\n\n    .navSection {\n        align-items: center;\n        flex-direction: row;\n        justify-content: space-between;\n        width: 100%;\n    }\n\n    .navLinks {\n        background-color: transparent;\n        box-shadow: none;\n        display: flex;\n        flex-direction: row;\n        position: relative;\n        width: auto;\n        z-index: 0;\n    }\n\n    .navLinks li:hover {\n        background-color: transparent;\n    }\n\n    .navLinks li a {\n        padding: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navContainer": `nav_navContainer__aVgoO`,
	"navLinks": `nav_navLinks__mbBvr`,
	"navSection": `nav_navSection__zD7ap`,
	"navLinksOpen": `nav_navLinksOpen__LzLhN`,
	"hamburger": `nav_hamburger__yCAAN`
};
export default ___CSS_LOADER_EXPORT___;
